const detectMobileAppWebView = (): boolean => {
    const { userAgent } = navigator;

    return /LumApps-WebInMobile\/([\w.]+)(?:-debug)?\((\d+)\) (\w+)\/([A-z0-9.]+)(?:\((\d+)\))?/.test(userAgent);
};

export type MobileOS = 'Android' | 'iOS' | 'webOS' | 'Opera Mini';
const detectMobileOS = (): MobileOS | undefined => {
    const { userAgent } = navigator;

    if (/android/i.test(userAgent)) {
        return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'iOS';
    }

    if (/webOS/.test(userAgent)) {
        return 'webOS';
    }

    if (/Opera Mini/.test(userAgent)) {
        return 'Opera Mini';
    }

    return undefined;
};

export { detectMobileAppWebView, detectMobileOS };
